import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SearchDataQuery, SearchDataQueryVariables } from './api.graphql';
import { SearchData } from './api.graphql';

/** @knip-ignore */
export type SearchPageFeatureConfigs = SearchDataQuery['featureConfigs'];

export type SearchPageData = {
	viewer: SearchDataQuery['viewer'];
	featureConfigs: SearchPageFeatureConfigs;
	countries: SearchDataQuery['countries'];
};

export async function getSearchPageData({ gql: { fetch } }: UtilityContext): Promise<SearchPageData> {
	const { data } = await fetch<SearchDataQuery, SearchDataQueryVariables>({
		query: SearchData,
		rejectOnError: true,
	});

	return {
		viewer: data.viewer,
		featureConfigs: data.featureConfigs,
		countries: data.countries,
	};
}
